<app-spinner-overlay></app-spinner-overlay>
<div>
  <header>
    <img [src]="logoPath" alt="Sostenibile" class="logo-path" />
  </header>
</div>
<div class="contenitore" *ngIf="!loading && !completato && strutturaValidazione">
  <div class="contenuto">
    <app-anteprima-validazione-iro
      [questionarioValidazione]="strutturaValidazione"
      [anteprima]="anteprima"
      (completato)="finitaCompilazione($event)"
      [isCompEsterna]="true"
      [landingPage]="landingPage"
    ></app-anteprima-validazione-iro>
  </div>
</div>

<div class="compilato" *ngIf="!loading && completato">
  Validazione completata. Grazie della sua disponibilità.
</div>

<div class="compilato" *ngIf="!loading && !completato && messaggio">
  {{ messaggio }}
</div>
